import React, { useMemo } from 'react';
import { FormData } from '../../types';
import RenderSection from '../renderSections';
import { useNotificationEmails } from '../../hooks/useNotificationEmails';
import { Button, Dimmer, Grid, Loader } from 'semantic-ui-react';

interface CapitalizationStepProps {
  estateId?: string;
}

const CapitalizationStep: React.FC<CapitalizationStepProps> = ({ estateId }) => {
  const defaultFormData: FormData = useMemo(
    () => ({
      creationResponsible: false,
      client: false,
      estateMain: false,
      estateManager: false,
      tempMail: '',
      additionalRecipient: []
    }),
    []
  );

  const subcategories = useMemo(() => ['newRequest', 'newFollowup', 'statusUpdate'], []);

  const titleMap: Record<string, string> = {
    newRequest: 'Nova Solicitação',
    newFollowup: 'Novo Followup',
    statusUpdate: 'Atualização de Status'
  };

  const {
    loading,
    formData,
    handleUpdateFormData,
    handleSave,
    isBackofficeTest
  } = useNotificationEmails({
    estateId,
    category: 'capitalization',
    subcategories,
    defaultFormData
  });

  return (
    <>
    <Dimmer active={loading} page>
        <Loader inline />
      </Dimmer>

      {subcategories.map(subcategory => (
        <RenderSection
          key={subcategory}
          title={titleMap[subcategory]}
          sectionKey={subcategory}
          formData={formData[subcategory]}
          onUpdate={handleUpdateFormData}
        />
      ))}
      <Grid style={{ marginLeft: '65%' }}>
        <Grid.Row columns={2} style={{ gap: '1rem' }}>
          <Button basic size="large" disabled={isBackofficeTest}>
            Cancelar
          </Button>
          <Button color="green" size="large" disabled={isBackofficeTest} onClick={handleSave}>
            Salvar alterações
          </Button>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default CapitalizationStep;
